module.exports = __webpack_public_path__ + "static/media/test17_4.73bfb225.png";